import React, { useState, useEffect } from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import ShipForm from "./ShipForm";
import ShipList from "./ShipList";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import ShipDetails from "./ShipDetails";
import ContractDetails from "./ContractDetails";
import AlertContact from "./AlertContact"
import CustomerContractDetails from "./CustomerContractDetails";
import { BreadcrumbPage } from "../../shared";
import TextField from "@material-ui/core/TextField";
import { getCookie } from "../../services/Cookies";
import { getRequest, postRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from '../../action';
import { useDispatch } from 'react-redux';
import moment from "moment";
import DialogContentText from '@material-ui/core/DialogContentText';
import { Box } from "@material-ui/core";
import Equipment from "./Equipment";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CancelIcon from '@mui/icons-material/Cancel';
import Button from "@material-ui/core/Button";
import Help from "@material-ui/icons/Help";
import ctrl from '../Helpsection_images/ctrl.jpg'
import clear from '../Helpsection_images/clear.jpg';
import cancel from '../Helpsection_images/cancel.jpg';
import applyfilter from '../Helpsection_images/applyfilter.jpg';
import ClearIcon from '@mui/icons-material/Clear';
import reset from '../Helpsection_images/reset.jpg';
import save from '../Helpsection_images/save.jpg';
import shipcancel from '../Helpsection_images/shipcancel.jpg';
const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    color: theme.palette.text.secondary,
  },
  gridSpacing: {
    margin: "0 !important",
    width: "100% !important",
  },
  btnFilters: {
    color: "#ff4717",
    border: "1px solid rgb(255 71 23)",
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ff4717",
    background: "#fff !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "20px"
  },
}));
export default function ShipMain(props) {
  const contacts = [
    {
      id: 1,
      shipName: "ATLANTA 1",
      shipSubName: "Assocoated Maritime Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 2,
      shipName: "ATLANTA 2",
      shipSubName: "Maerks",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 3,
      shipName: "ATLANTA 3",
      shipSubName: "XYZ",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      shipOwner: "Gulf",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 4,
      shipName: "ATLANTA 4",
      shipSubName: " Maritime Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 5,
      shipName: "ATLANTA 5",
      shipSubName: "Shell",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      shipOwner: "Gulf",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 6,
      shipName: "ATLANTA 6",
      shipSubName: "Fleet",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      shipOwner: "Gulf",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 7,
      shipName: "ATLANTA 7",
      shipSubName: "",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 8,
      shipName: "ATLANTA 8",
      shipSubName: " Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 9,
      shipName: "ATLANTA 9",
      shipSubName: "Assocoated Maritime Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      shipOwner: "Gulf",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 10,
      shipName: "ATLANTA 10",
      shipSubName: "Assocoated Maritime Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      shipOwner: "Gulf",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
  ];
  const BreadcrumbList = [
    { name: "Assets", url: "/dashboard/assets" },
    { name: "Ship Details", url: "/dashboard/assets" },
    // { name: "Atlanta 1", url: "/dashboard/assets" },
  ];
  const dispatch = useDispatch();
  const [scroll, setScroll] = React.useState('paper');
  const [shipId, setShipId] = useState(contacts ? contacts[0] : {});
  const [shipList, setShipList] = useState([]);
  const [customerContractList, setCustomerContractList] = useState([]);
  const [contractList, setContractList] = useState([]);
  const [seletedShip, setSeletedShip] = useState([]);
  const [customerData, setCustomerData] = React.useState([]);
  const [equipmentData, setEquipmentData] = React.useState([]);
  const [typeOfShipData, setTypeOfShipData] = React.useState([]);
  const [dataOfEquipement, setDataOfEquipement] = useState({});
  const [fullWidth, setFullWidth] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [formOpen, setFormOpen]= React.useState(false);
  const [CurrentEquipment, setCurrentEquipment] = React.useState();
  const [frequencyRange, setFrequencyRange] = React.useState()
  const [checkBox, setCheck] = React.useState({ disabled: true, checked: false });
  const classes = useStyles();
const handleClickOpen = () => {
    setFormOpen(true);
    }
     const handleClickClose = () => {
       setFormOpen(false);
     };
  useEffect(() => {

    // getEquipementShipData(props.location.data.vesselKey);
    
    //fetchBasicData();
    if (getCookie('type') !== "VPS Admin")
    {
    let getCookieval = "";
    if (localStorage.getItem('FilterSetting') !== "" && localStorage.getItem('FilterSetting') !== undefined && localStorage.getItem('FilterSetting') !== null && localStorage.getItem('FilterSetting') !== "null") {
      getCookieval = localStorage.getItem('FilterSetting')
    }
    else {
      getCookieval = localStorage.getItem('GlobalFilterSetting')
    }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      onFetchFitterObject(Obj);

    }else{
    onFetchFitterObject();
    }
  }
  else{
    let getCookieval = localStorage.getItem('GlobalFilterSetting');
    
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      //onFetchFitterObject();
    }
  }
  }, []);
  const getShipListDataNew = () => {
    let getCookieval = localStorage.getItem('GlobalFilterSetting');
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      onFetchFitterObject(Obj);

    }else{
      onFetchFitterObject();
    }
   
  }
  const fetchBasicData = async () => {
    dispatch({ type: LOADING, payload: true });
    await getCustomerData();
    await getEquipmentData();
    await getTypeOfShipDate();
    await getShipListData(getCookie("clientId"));
    dispatch({ type: LOADING, payload: false });
  }

  const seletedShipItemList = (row) => {
    //
    getCustomerContractData(row.vesselKey);
    getContractData(row.vesselKey);
    setSeletedShip(row);
    getEquipementShipData(row.vesselKey);

  }

  const onFetchFitterObject = (formObj) => {
    //
    let filterObj = {}
    let Data={};
    if(formObj!==""&&formObj!==undefined){
    if (formObj.customerNameKey&&formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
    if (formObj.shipNameImokey&&formObj.shipNameImokey.length > 0) { filterObj = { ...filterObj, shipNameImokey: formObj.shipNameImokey } }
    if (formObj.lubeequipname&&formObj.lubeequipname.length > 0) { filterObj = { ...filterObj, lubeequipname: formObj.lubeequipname } }
    if (formObj.lubeequipmodel&&formObj.lubeequipmodel.length > 0) { filterObj = { ...filterObj, lubeequipmodel: formObj.lubeequipmodel } }
    if (formObj.lubeequipmake&&formObj.lubeequipmake.length > 0) { filterObj = { ...filterObj, lubeequipmake: formObj.lubeequipmake } }
    // if (data.customer) { filterObj = { ...filterObj, customerKey: data.customer } }
    // if (data.make) { filterObj = { ...filterObj, make: data.make } }
    // if (data.equipement) { filterObj = { ...filterObj, equipment: data.equipement } }
    // if (data.typeofShip) { filterObj = { ...filterObj, typeOfShip: data.typeofShip } }
    // if (data.vessel) { filterObj = { ...filterObj, vessel: data.vessel } }
    // if (data.model) { filterObj = { ...filterObj, model: data.model } }
    dispatch({ type: LOADING, payload: true });
    const myJSONData = JSON.stringify(filterObj);
     Data = {
      Data: myJSONData,
    }
  }
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/Filter`;
    postRequest(url, Data)
      .then((res) => {
       
        //console.log(res.data);
        if (res.data.length) {
          //
          dispatch({ type: LOADING, payload: false });
          setShipList(res.data);
          getCustomerContractData(res.data[0].vesselKey);
          getContractData(res.data[0].vesselKey);
          setSeletedShip(res.data[0]);
          getEquipementShipData(res.data[0].vesselKey)
        } else {
          dispatch({ type: LOADING, payload: false });
          setShipList([]);
          setCustomerContractList([]);
          setContractList([]);
          setSeletedShip([]);
          setDataOfEquipement([]);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });

  }
  const onChecked = (value) => {
    //
    if (value == true) {
      setCheck({ ...checkBox, ...{ checked: value } })
      setFrequencyRange("0")
    } else {
      setCheck({ ...checkBox, ...{ checked: value } })
      setFrequencyRange("");
    }

  }
  const getCustomerData = async () => {
    // dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Customer`;
    await getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          // dispatch({ type: LOADING, payload: false });
          setCustomerData(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  };

  const getEquipmentData = async () => {
    // dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Ship/Equipments`;
    await getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          // dispatch({ type: LOADING, payload: false });
          setEquipmentData(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  };

  const getTypeOfShipDate = async () => {
    // dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Ship/VesselTypes`;
    await getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setTypeOfShipData(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  };


  const getShipListData = async (customerKey) => {
    //
    // dispatch({type:LOADING, payload: true});
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/${customerKey}`;
    await getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          // dispatch({type:LOADING, payload: false});
          setShipList(res.data);
          getCustomerContractData(res.data[0].vesselKey);
          getContractData(res.data[0].vesselKey);
          setSeletedShip(res.data[0]);
          getEquipementShipData(res.data[0].vesselKey)
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({type:LOADING, payload: false});
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getCustomerContractData = (vesselKey) => {
    //
    // dispatch({type:LOADING, payload: true});
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/ContractsDetails/${vesselKey}`;
    getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          // dispatch({type:LOADING, payload: false});
          setCustomerContractList(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        // dispatch({type:LOADING, payload: false});
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getContractData = (vesselKey) => {
    // dispatch({type:LOADING, payload: true});
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/Contacts/${vesselKey}`;
    getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          // dispatch({type:LOADING, payload: false});
          setContractList(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }
  const getEquipementShipData = (vesselKey) => {
    //
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/Equipment/${vesselKey}`;
    getRequest(url)
      .then((res) => {
        res.data.forEach((d) => {
          if(d.lastSamplingDate){
          d.lastSamplingDate = moment(d.lastSamplingDate).format('DD/MM/YYYY');
          }
          if(d.nextSamplingDate){
          d.nextSamplingDate = moment(d.nextSamplingDate).format('DD/MM/YYYY');
          }
        })
        ////console.log(res);
        if (res.data.length) {
          setDataOfEquipement(res.data);
        } else {
          setDataOfEquipement([]);
        }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        // setDataOfEquipement(shipDatObj);
        setDataOfEquipement([]);

        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  }
  const clearFilter = () => {
    //getShipListData(getCookie("clientId"));
    getShipListDataNew();
  }
  const handleClose1 = () => {
    setOpen(false);
  };
  const onEditSubmit = (value) => {
    //let val=dataOfEquipement[value.rowIndex]
    
let val=dataOfEquipement[value.index]
    if (val.frequency == 0) {
      setCheck({ ...checkBox, ...{ checked: true } })
      setFrequencyRange("0")
    } else if (val.frequency != 0) {
      setCheck({ ...checkBox, ...{ checked: false } })
      setFrequencyRange("");
    }
    setOpen(true);
    setCurrentEquipment(val);

  }
  const oninputChange = (value, field) => {
    //
    setFrequencyRange(value)
    console.log(frequencyRange);
  }
  const handleSubmit = () => {
    //
    if (frequencyRange != "") {
      dispatch({ type: LOADING, payload: true });
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/updateEquipment/${CurrentEquipment.vpsId}/${frequencyRange}`;
      postRequest(url)
        .then((res) => {
          ////console.log(res);
          if (res.data.length) {
            dispatch({ type: LOADING, payload: false });
            seletedShipItemList(seletedShip);
            handleClose1();
            ToastError("Updated Successfully");
            //setCheck({ ...checkBox, ...{ checked: false } })
          } else {
            ToastError("Updated UnSuccessfully");
          }
          dispatch({ type: LOADING, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADING, payload: false });
          // setDataOfEquipement(shipDatObj);
          setDataOfEquipement([]);

          ////console.log(error);
          ToastError(error.response.data.message);
        });
    } else {
      ToastError("Fill the new sampling Frequency");
    }

  }
  return (
    <>
    <div>
      <Box component="div" className="pos_relative">
                      <Dialog
                        open={formOpen}
                        scroll={scroll}
                        aria-labelledby="scroll-dialog-title"
                        aria-describedby="scroll-dialog-description"
                         >
                        <DialogTitle id="scroll-dialog-title" color="white">Assets</DialogTitle>
                        <DialogContent dividers={scroll === 'paper'}>
                            <DialogContentText
                                id="scroll-dialog-description"
                                //ref={descriptionElementRef}
                                tabIndex={-1}
                            >
                               <p className="subtitle">Help On Filter Panel</p><br />
                               <img className="maxwidth100" src="/assets/images/Assets-Ship Details-Filter.jpg"></img><br /><br />
                                <p>
                                  <li>Click and type on the fields to see the options</li><br/>
                                  <li>For multiple selections hold <img src={ctrl}  width="40px" height="40px"/> to select options from the list</li><br/>
                                  <li>Click <ClearIcon color="disabled"/> to clear all the selection in a particular field<img src={clear} alt="" width="300px" height="300px"/></li><br/>
                                  <li>Click <CancelIcon color="disabled"/> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px"/> </li><br/>
                                  <li>Click on <img src={applyfilter} alt="" width="100px" height="100px"/> to apply selected filters</li><br/>
                                  <li>Click on <img src={reset} alt="" width="70px" height="70px"/> will revert changes made in filter panel and set it to default global filter values</li><br/>
                                  <p><span style={{color:"#ff4717"}}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                                </p><br/>
                                <p className="subtitle">Help On Ship Section</p><br/>
                                <img className="maxwidth100" src="/assets/images/Assets-Ship Details.jpg"></img><br /><br />
                                <p>
                                  <li>Select ship from ship list in the left corner</li><br/>
                                  <li>Selected ship detail will display in ship details section</li><br/>
                                  <li>Selected ship contact details will display in Contact Details section</li><br/>
                                  <li>Selected ship customer and contract details will display in Customer and Contract Details section</li><br/>
                                  <img className="maxwidth100" src="/assets/images/Assets Equipment.jpg"></img><br /><br />
                                  <li>Selected ship equipment details will display in Equipment section</li><br/>
                                  <li>Click on Edit can edit the sampling frequency manually</li><br/>
                                  <li>Click on <img src={save}  width="70px" height="70px"/> will save the edited sampling frequency</li><br/>
                                  <li>Click on <img src={shipcancel}  width="70px" height="70px"/> cancel will cancel the edited sampling frequency</li><br/>
                                </p>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClickClose}>Close</Button>
                        </DialogActions>
                    </Dialog>
                    </Box>
                    </div>
    <Box component="div" px={2} className={classes.root}>
      <Dialog
        //fullWidth={fullWidth}
        //maxWidth={maxWidth}
        maxWidth="xl"
        // fullScreen={true}
        open={open}
        onClose={handleClose1}
        style={{ width: "600px !important", margin: "0px auto" }}
        className="diaglogc1"
      >
        <DialogActions>
          <Grid container spacing={3} >

            <Grid item md="8">

              <DialogTitle id="alert-dialog-title" > {"Edit Sampling Frequency days"}</DialogTitle>
            </Grid>
            <Grid item md="4" className="btnclose">
              <Button onClick={handleClose1}><CancelIcon /></Button>

            </Grid>
          </Grid>
        </DialogActions>
        {/* <DialogTitle id="alert-dialog-title"> {"Wheather you want to Edit Frequency range of Equipment?"}</DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {checkBox.checked == true ? "" :
              <Grid container spacing={3} >
                <Grid item md="6">
                  <p style={{ lineHeight: "60px !important" }}>{"Old Sampling Frequency days:"}</p>
                </Grid>
                <Grid item md="6">
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    //fullWidth
                    // name="search"
                    inputProps={{ readOnly: true }}
                    className={classes.txtInput}
                    placeholder="Sampling Days"
                    type={"number"}
                    value={CurrentEquipment ? CurrentEquipment.frequency : ""}
                  //onChange={(e) => oninputChange(e.target.value, "Frequencyrange")}
                  />
                </Grid>
              </Grid>
            }
            <Grid container spacing={3} >
              <Grid item md="6">
                <p style={{ lineHeight: "60px !important" }}>{""}</p>
              </Grid>
              <Grid item md="6">
                <FormControlLabel
                  control={
                    <Checkbox
                      name="checkedA"
                      //disabled={checkBox.disabled}
                      checked={checkBox.checked}
                      onChange={(e) => onChecked(e.target.checked)}
                    />
                  }
                  label="Ad hoc"
                  color="primary"
                  labelPlacement=" insidelabel"
                />
                {/* <FormControl >
                            <RadioGroup aria-label="aseets" name="aseets" value={assetValueSchedular} onChange={handleAssetRadioChangeSchedular} >
                              <FormControlLabel
                                 onChange={()=>{navigationToPage("Ship_Page")}}
                                value="Ship_Page" control={<Radio />} color="secondary" label="Adhok" />
                             
                            </RadioGroup>
                          </FormControl>   */}
              </Grid>
            </Grid>
            {checkBox.checked == true ? "" :
              <Grid container spacing={3} >
                <Grid item md="6">
                  <p style={{ lineHeight: "60px !important" }}>{"New Sampling Frequency days:"}</p>
                </Grid>
                <Grid item md="6">
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    //fullWidth
                    // name="search"
                    className={classes.txtInput}
                    placeholder="Sampling Days"
                    type={"number"}

                    //onChange={(e) => oninputChange(e.target.value, "Frequencyrange")}
                    onChange={(event) =>
                      oninputChange(event.target.value < 0
                        ? (event.target.value = 0)
                        : event.target.value, "Frequencyrange")
                    }
                  />
                </Grid>
              </Grid>
            }




          </DialogContentText>
        </DialogContent>

        <DialogActions textAlign="center" className="mr-20 mb15">

          <Box>
            <Button onClick={() => { handleSubmit() }} className={classes.btnStyle2} color="primary">
              Save
            </Button>
            <Button onClick={() => { handleClose1() }} className={classes.btnStyle1} color="primary">
              Cancel
            </Button>

          </Box>

        </DialogActions>




      </Dialog>
      <Grid container spacing={3} className={classes.gridSpacing}>
        <Grid className="breadcrum assets" item xs={12}>
          <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpen}/>}/>
        </Grid>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <ShipForm fetchFitterObject={onFetchFitterObject} clearFilter={clearFilter} customerData={customerData} equipmentData={equipmentData} typeOfShipData={typeOfShipData} customerContractList={customerContractList} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={2}>

          <ShipList seletedShipItemList={seletedShipItemList} shipList={shipList} />

        </Grid>
        <Grid item xs={12} md={10}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <ShipDetails dataSource={shipId} seletedShip={seletedShip} />
            </Grid>
            <Grid item xs={12}>
              {console.log("seletedShip.vesselKey",seletedShip.vesselKey)}
              <AlertContact vesselkey={seletedShip.vesselKey}/>
            </Grid>
            <Grid item xs={12}>
              <ContractDetails contractList={contractList} />
            </Grid>
            <Grid item xs={12}>
              <CustomerContractDetails customerContractList={customerContractList} />
            </Grid>

          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Equipment rows={BreadcrumbList} dataOfEquipement={dataOfEquipement} onHandleSubmit={onEditSubmit}></Equipment>
          </Paper>
        </Grid>
      </Grid>
    </Box>
    </>
  );
}
